import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Advantages from './components/Advantages';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Advantages />
        <Portfolio />
        <Contact />
      </main>
      <footer className="bg-[#1E3A5F] text-white py-8 text-center">
        <div className="container mx-auto px-4">
          <p className="text-sm opacity-80 mb-3">
            © 2025 Loïc Duperron - Création de sites internet professionnels
          </p>
          <div className="flex justify-center gap-6 flex-wrap text-sm">
            <a 
              href="/mentions-legales.html" 
              className="opacity-80 hover:opacity-100 hover:text-[#FF9933] transition-all duration-200"
            >
              Mentions légales
            </a>
            <span className="opacity-50">•</span>
            <a 
              href="/confidentialite.html" 
              className="opacity-80 hover:opacity-100 hover:text-[#FF9933] transition-all duration-200"
            >
              Confidentialité
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
